export default function CompletionIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#D7FFEB" />
      <path
        d="M13 22.5C13 22.5 14.5 22.5 16.5 26C16.5 26 22.0588 16.8333 27 15"
        stroke="#11A75C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
